import React from 'react';
import Link from 'gatsby-link';

const Footer = ({ id }) => (
  <div className="content-wrapper" data-for="page-footer">
    <footer id={id}>
      <Link to="/"><img src="" alt="Marcos Abreu - web architect/engineer" /></Link>
      <nav id="social-links">
        <ul>
          <li><Link to="/todo">Stack Overflow</Link></li>
          <li><Link to="/todo">Linked-in</Link></li>
          <li><Link to="/todo">Gitlab</Link></li>
          <li><Link to="/todo">Github</Link></li>
        </ul>
      </nav>
    </footer>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js